
/* injects from baggage-loader */

import React, { Component } from "react";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";

class TerminalError extends Component {
    render () {
        let { data } = this.props;
        return <div className="ticket-results-view-p">
            <div className="popup-message error" onClick={data.close && this.props.openPopup("LoginForm", {disable: this.props.disable, signInToAdmin: true, from: "terminal-error", data: data})}/>
            <h3>
                {typeof data === "object" ? data.errorText || data.error : data}
            </h3>
        </div>;
    }
}

TerminalError.propTypes = {
    data: PropTypes.any,
    openPopup: PropTypes.func,
    disable: PropTypes.bool
};

export default connect()(UIMixin({Component: TerminalError}));